import { Button, HStack, Icon, Text } from "@chakra-ui/react";
import { LogOut } from "lucide-react";
import type { LogoutButtonProps } from "./types";
import { logoutButtonStyles, collapsedNavButtonStyles } from "./styles";

const LogoutButton = ({ onLogout, isLoading, isCollapsed = false }: LogoutButtonProps) => {
  const getButtonStyles = () => {
    if (isCollapsed) {
      return {
        ...collapsedNavButtonStyles,
        color: "error.solid",
        _hover: { 
          bg: "error.subtle", 
          color: "error.dark",
          _dark: { bg: "error.muted", color: "error.light" } 
        },
        _active: { 
          bg: "error.muted", 
          _dark: { bg: "error.subtle" } 
        },
      };
    }
    return logoutButtonStyles;
  };

  return (
    <Button
      {...getButtonStyles()}
      onClick={onLogout}
      loading={isLoading}
      loadingText={isCollapsed ? "" : "Logging out..."}
      title={isCollapsed ? "Logout" : undefined}
    >
      {isCollapsed ? (
        <Icon as={LogOut} boxSize={4} />
      ) : (
        <HStack gap={3} w="full">
          <Icon as={LogOut} boxSize={4} />
          <Text>Logout</Text>
        </HStack>
      )}
    </Button>
  );
};

export default LogoutButton; 